// extracted by mini-css-extract-plugin
module.exports = {"primary":"#51bac0","white":"#fff","weixinColor":"#09BB07","alipayColor":"#1777FF","successColor":"#07c160","errorColor":"#ee0a24"};